import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 132.283 132.283"
  }, props), {}, {
    children: /*#__PURE__*/_jsxs("g", {
      transform: "matrix(1.33333 0 0 -1.33333 0 132.283)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M99.078 49.742C99.078 22.419 76.928.27 49.606.27 22.284.27.135 22.419.135 49.74c0 27.323 22.149 49.472 49.47 49.472 27.324 0 49.473-22.15 49.473-49.471",
        fill: "none",
        stroke: "none",
        strokeMiterlimit: 10
      }), /*#__PURE__*/_jsx("path", {
        d: "M66.593 27.012h2.836v17.771h-2.836v-7.488h-8.864V27.012h2.835v7.447h6.029v-.728zM32.62 33.731v.73h6.03v-7.449h2.835v10.283H32.62v7.49h-2.836V27.011h2.836z",
        fill: "currentColor"
      }), /*#__PURE__*/_jsx("path", {
        d: "M32.678 54.065c.725 8.703 8.04 15.566 16.93 15.566 8.887 0 16.205-6.863 16.926-15.566zM48.19 27.012h2.833V51.23h18.405v1.417c0 10.93-8.891 19.824-19.82 19.824-10.93 0-19.823-8.895-19.823-19.824V51.23H48.19z",
        fill: "currentColor"
      })]
    })
  }));
};
export default SvgComponent;